import React, { useRef, useState, useEffect } from "react";

function BaseChartCarousel({ children, title, previousAlt = "", nextAlt = "" }) {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 5);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);

      const itemWidth = clientWidth * 0.85 + 16;
      const index = Math.round(scrollLeft / itemWidth);
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  const scrollToIndex = (directionOrIndex) => {
    if (scrollRef.current) {
      const { clientWidth } = scrollRef.current;
      const itemWidth = clientWidth * 0.85 + 16;

      let newIndex = activeIndex;

      if (directionOrIndex === "next") {
        newIndex = activeIndex + 1;
      } else if (directionOrIndex === "prev") {
        newIndex = activeIndex - 1;
      } else {
        newIndex = directionOrIndex;
      }

      scrollRef.current.scrollTo({
        left: newIndex * itemWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="base-chart-carousel-wrapper">
      <div className="scc-header">
        <h4 className="carousel-title margin-reset">{title}</h4>
        <div className="scc-arrows">
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/arrow_down.svg`}
            alt={previousAlt}
            className="arrow-carousel arrow-left"
            onClick={() => canScrollLeft && scrollToIndex("prev")}
            style={{
              cursor: canScrollLeft ? "pointer" : "default",
              opacity: canScrollLeft ? 1 : 0.2,
            }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/arrow_down.svg`}
            alt={nextAlt}
            className="arrow-carousel arrow-right"
            onClick={() => canScrollRight && scrollToIndex("next")}
            style={{
              cursor: canScrollRight ? "pointer" : "default",
              opacity: canScrollRight ? 1 : 0.2,
            }}
          />
        </div>
      </div>

      <div
        className="base-chart-snap-container"
        ref={scrollRef}
        onScroll={checkScroll}
      >
        {React.Children.map(children, (child) => (
          <div className="chart-snap-item">{child}</div>
        ))}
      </div>

      {/* Pill Pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "6px",
        }}
      >
        {React.Children.map(children, (_, i) => (
          <div
            key={i}
            onClick={() => scrollToIndex(i)}
            style={{
              cursor: "pointer",
              transition: "all 0.3s ease",
              width: i === activeIndex ? "14px" : "6px",
              height: "6px",
              borderRadius: "9999px",
              backgroundColor:
                i === activeIndex ? "var(--primary-500, #004789)" : "#D1D1D1",
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default BaseChartCarousel;
